angular.module('app.filters').filter('numberWithUnit', ($filter) => {
  'ngInject';
  let numberFilter = $filter('number');
  return (number, fractionSize, unit) => {
    if (!number) return '';
    if (!unit) unit = '';
    return `${numberFilter(number, fractionSize)} ${unit}`;
  };
});



// WEBPACK FOOTER //
// ./app/filters/number-with-unit.js